import {createFileRoute} from '@tanstack/react-router';
import {BankIDPage} from 'pages/bankid/BankIDPage';

export const Route = createFileRoute('/_protected/bankid')({
  component: BankIDPage,
});
